var tooltipTriggers = document.querySelectorAll('.tooltip__trigger');
var tooltipClose = document.querySelectorAll('.tooltip__overlay__close');

tooltipClose.forEach(function (close) {
  close.addEventListener('click', (e)=>{
    var allWrapper = document.querySelectorAll('.tooltip__overlay');
    allWrapper.forEach(function (wrapper) {
      wrapper.classList.remove('is-active');
    });
  });
});


tooltipTriggers.forEach(function (trigger) {
  trigger.addEventListener('click', (e)=>{
    var id = trigger.dataset.tooltip;
    var wrapper = document.querySelector('.tooltip__overlay--' + id);
    wrapper.classList.add('is-active');
  })
});


